import {KpiType} from '@hconnect/common/types'
import {Modal, ModalContent, ModalTitle} from '@hm/fundamental'
import {useMediaQuery, useTheme, Collapse} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {AddPerformanceReviewCommentForm} from '../components'
import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  isOpen: boolean
  onAddComment: (comment: string, kpiType: KpiType) => Promise<void>
  onCancel: () => void
}

export const AddPerformanceReviewCommentContainer = ({isOpen, onAddComment, onCancel}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const form = (
    <AddPerformanceReviewCommentForm
      onAddComment={onAddComment}
      onCancel={onCancel}
      isMobile={isMobile}
    />
  )

  if (isMobile) {
    return (
      <Modal open={isOpen} onClose={onCancel}>
        <ModalTitle>{t('comments.label.addComment')}</ModalTitle>
        <ModalContent>{form}</ModalContent>
      </Modal>
    )
  }

  return (
    <Collapse in={isOpen}>
      <div className="pb-4">{form}</div>
    </Collapse>
  )
}
